export default "__VITE_ASSET__585e2761__"